const productquestion = {
    getlist: 'productquestion/getlist',
    add: 'productquestion/add',
    update: 'productquestion/update',
    remove: 'productquestion/remove',
    get: 'productquestion/get',
}
export default productquestion
